module.exports = __webpack_public_path__ + "media/images/landing/bg/case-emco/instagram-1-6fd845360d22a0160a438febb3a336a0.jpg";